import React, { useState } from 'react';
// Script Path & Filename: src/components/Login.jsx

export const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            const contentType = res.headers.get('content-type') || '';
            let data = {};
            if (contentType.includes('application/json')) {
                data = await res.json();
            } else {
                const text = await res.text();
                throw new Error(`Server Response Error (${res.status}): Credentials invalid or gateway error.`);
            }
            if (!res.ok) throw new Error(data.error || 'Connection failed');
            onLogin(data);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-900">
            <div className="bg-slate-800 p-8 rounded-lg shadow-xl w-96 border border-slate-700">
                <div className="mb-8 text-center">
                    <h1 className="text-2xl font-bold text-blue-500 tracking-wider">SAPPHIRE</h1>
                    <p className="text-slate-400 text-sm mt-1">Command Center Interface</p>
                </div>
                {error && <div className="bg-red-500/10 border border-red-500/50 text-red-400 p-3 rounded mb-4 text-sm">{error}</div>}
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="block text-sm font-medium mb-1 text-slate-400">Technician ID</label>
                        <input type="text" value={username} onChange={e => setUsername(e.target.value)} required autoComplete="username"
                               className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2.5 text-white focus:outline-none focus:border-blue-500 transition-all" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-1 text-slate-400">Passcode</label>
                        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password"
                               className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2.5 text-white focus:outline-none focus:border-blue-500 transition-all" />
                    </div>
                    <button type="submit" className="w-full bg-blue-600 hover:bg-blue-500 text-white font-medium py-2.5 rounded transition-colors mt-2">
                        Initialize Session
                    </button>
                </form>
            </div>
        </div>
    );
};